<template>
  <div class="videopreview-wrapper">
      <video class="videopreview-video-element" oncontextmenu="return false;"  disablePictureInPicture controls autoplay controlsList="nodownload" name="media">
          <source :src="fileUrl"/>
      </video>
  </div>
</template>

<script>
export default {
   name:'VideoFilePreview',
   props:['url'],
   data(){
      return {
          fileUrl:'',
      }
  },
  mounted(){
      this.fileUrl = this.url;
  }
}
</script>

<style>
  .videopreview-video-element{
    position: absolute;
    width: 100%;
    height: 100%;
    inset-inline-start: 0;
    top: 0;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
    bottom: 0;
    user-select: none;
  }
  .videopreview-wrapper{
     position: relative;
     width: 100%;
     height: 100%;
  }
</style>